import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ISelectItem } from '../../../store/models/select.model';
import {
  BillingDesignation,
  BillingDesignationLabels,
  BillingDesignationValue,
  billingDesignationLabel,
  isOffAppBilled,
} from '../../../store/models/account.model';

export const BILLING_MODE_BILLABLE = 'billable';
export const BILLING_MODE_NOT_BILLABLE = 'not_billable';

@Component({
  selector: 'app-mark-not-billable-dialog',
  templateUrl: './mark-not-billable-dialog.component.html',
  styleUrls: ['./mark-not-billable-dialog.component.scss'],
})
export class MarkNotBillableDialogComponent implements OnInit {

  @Input() inputForm: FormGroup;
  @Input() billingDesignationLabels: BillingDesignationLabels = {};
  @Input() billing_designation: BillingDesignationValue | string | null = null;
  @Input() invoice_note: string | null = null;

  designationItems: ISelectItem[] = [];

  readonly modeBillable = BILLING_MODE_BILLABLE;
  readonly modeNotBillable = BILLING_MODE_NOT_BILLABLE;

  ngOnInit(): void {
    this.designationItems = [
      BillingDesignation.QUICKBOOKS,
      BillingDesignation.NO_BILLING,
    ].map(value => ({
      label: billingDesignationLabel(value, this.billingDesignationLabels),
      value,
    }));

    if (!this.inputForm) {
      return;
    }

    const initiallyNotBillable = isOffAppBilled(this.billing_designation);
    const initialMode = initiallyNotBillable
      ? BILLING_MODE_NOT_BILLABLE
      : BILLING_MODE_BILLABLE;
    const initialDesignation = initiallyNotBillable
      && (this.billing_designation === BillingDesignation.QUICKBOOKS
        || this.billing_designation === BillingDesignation.NO_BILLING)
      ? this.billing_designation
      : BillingDesignation.QUICKBOOKS;
    const initialNote =
      initiallyNotBillable && this.billing_designation === BillingDesignation.NO_BILLING
        ? (this.invoice_note || '')
        : '';

    this.inputForm.addControl(
      'billing_mode',
      new FormControl(initialMode, [Validators.required]),
    );
    this.inputForm.addControl(
      'billing_designation',
      new FormControl(initialDesignation, []),
    );
    this.inputForm.addControl('invoice_note', new FormControl(initialNote, []));

    this.inputForm.get('billing_mode').valueChanges.subscribe(mode => {
      this.applyMode(mode);
    });
    this.inputForm.get('billing_designation').valueChanges.subscribe(value => {
      if (this.isNotBillableMode) {
        this.updateInvoiceNoteValidators(value);
      }
    });
    this.applyMode(initialMode);
  }

  get isNotBillableMode(): boolean {
    return this.inputForm?.get('billing_mode')?.value === BILLING_MODE_NOT_BILLABLE;
  }

  get showInvoiceNote(): boolean {
    return this.isNotBillableMode
      && this.inputForm?.get('billing_designation')?.value === BillingDesignation.NO_BILLING;
  }

  private applyMode(mode: string): void {
    const designation = this.inputForm.get('billing_designation');
    const note = this.inputForm.get('invoice_note');
    if (!designation || !note) {
      return;
    }

    if (mode === BILLING_MODE_BILLABLE) {
      designation.clearValidators();
      note.clearValidators();
      designation.updateValueAndValidity({ emitEvent: false });
      note.updateValueAndValidity({ emitEvent: false });
      return;
    }

    designation.setValidators([Validators.required]);
    if (!designation.value) {
      designation.setValue(BillingDesignation.QUICKBOOKS, { emitEvent: false });
    }
    designation.updateValueAndValidity({ emitEvent: false });
    this.updateInvoiceNoteValidators(designation.value);
  }

  private updateInvoiceNoteValidators(designation: string): void {
    const note = this.inputForm.get('invoice_note');
    if (!note) {
      return;
    }
    if (designation === BillingDesignation.NO_BILLING) {
      note.setValidators([Validators.required]);
    } else {
      note.clearValidators();
      if (note.value) {
        note.setValue('', { emitEvent: false });
      }
    }
    note.updateValueAndValidity();
  }
}
